import { render, staticRenderFns } from "./payment-method.vue?vue&type=template&id=b97d01b0&scoped=true&"
import script from "./payment-method.vue?vue&type=script&lang=js&"
export * from "./payment-method.vue?vue&type=script&lang=js&"
import style0 from "./payment-method.vue?vue&type=style&index=0&id=b97d01b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97d01b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b97d01b0')) {
      api.createRecord('b97d01b0', component.options)
    } else {
      api.reload('b97d01b0', component.options)
    }
    module.hot.accept("./payment-method.vue?vue&type=template&id=b97d01b0&scoped=true&", function () {
      api.rerender('b97d01b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/pro/field-template/payment-method.vue"
export default component.exports